<template>
    <div class="page container workshopDetail meeting">
        <div class="container-zoom">
            <!-- <ZoomFrame :nickname="nickname" :meetingId="meetingId"/> -->
            <p>{{ signature }}</p>
        </div>
    </div>
</template>

<script>
    // import ZoomFrame from "../components/ZoomFrame.vue"

    export default {
        name: "app",
        data: function () {
            return {
                nickname: '',
                meetingId: '',
                signature: null
            }
        },
        components: {
            // ZoomFrame,
        },
        created(){

            let self = this

            this.nickname = this.$route.query.nickname
            this.meetingId = this.$route.query.meetingId

            self.$http.post('https://us-central1-vanmgl.cloudfunctions.net/GetZoomSignature', {
                role: 0,
                meetingNumber: 96323058675
            }).then(response => {
                
                console.log('Signature: ', response)

                if(response.status === 200){
                    self.signature = response.body.signature
                }
            })
            .catch((err) => {
                console.log('Error getting zoom signature: ', err)
            })
        }
    }
</script>

<style>
    .container-zoom {
        width: 70%;
        height: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/views/WorkshopMeeting.vue